export class Config {
  public backendUrl = 'http://37.59.172.198:3000/';
}



// WEBPACK FOOTER //
// C:/Users/HP Spectre/Desktop/Regineh Hotel/reginehUser/src/app/config.ts